const SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const WEB_ADDRESS = /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(?::\d+)?(?:[/?#]|$)/i;

/** Gives a schemeless web address such as `www.site.com/page` the https scheme. */
export function withWebScheme(href: string): string {
  const value = href.trim();
  if (value.startsWith('//')) return `https:${value}`;
  if (SCHEME.test(value)) return value;
  return WEB_ADDRESS.test(value) ? `https://${value}` : value;
}

/**
 * Makes every `<a>` look and resolve the same, whichever editor wrote it: an absolute href
 * and the `link` class that post styles colour. The mobile editor writes neither.
 */
export function normalizeLinkHtml(html: string): string {
  return html.replace(/<a\b([^>]*)>/gi, (_tag, attributes: string) => {
    let next = attributes.replace(
      /\bhref=(["'])(.*?)\1/i,
      (_href, quote: string, value: string) => `href=${quote}${withWebScheme(value)}${quote}`,
    );
    const classMatch = next.match(/\bclass=(["'])(.*?)\1/i);
    if (!classMatch) {
      next = `${next} class="link"`;
    } else if (!classMatch[2].split(/\s+/).includes('link')) {
      next = next.replace(
        classMatch[0],
        `class=${classMatch[1]}${classMatch[2]} link${classMatch[1]}`,
      );
    }
    return `<a${next}>`;
  });
}
